import React from 'react';
import moment from 'moment';
import {baseURLWeb} from '../../misc/http';
import logoKominfo from '../../assets/logo-kominfo.png';
import QRCode from 'qrcode-react';
import Modal from '../../layout/Modal'

export default ({organizer, showForm, handleClose}) => {
  const qrCodeURL = baseURLWeb+'listPSrE/'+organizer._id
  return (
    // <div className={`modal fade ${showForm}`} id="detail-pt-privy-identitas-digital-789-2019" tabindex="-1" role="dialog" aria-labelledby="detail-pt-privy-identitas-digital-789-2019" aria-hidden="true" style={showForm === 'show' ? {display: 'block'} : {display:'none'}}>
    <Modal show={showForm} handleClose={handleClose}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header" style={{padding: '20px 30px'}}>
            <h3 className="modal-title">Detail Pengakuan PSrE</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={() => handleClose()}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body" style={{padding: '30px'}}>
            <div className="row">
              <div className="col-md-6">
                <table className="table table-modal" style={{fontSize: '13px'}}>
                  <tbody>
                    <tr>
                      <th style={{width: '40%'}}>Nama Perusahaan</th>
                      <td>: </td>
                      <td>{organizer ? organizer.companyName : null}</td>
                    </tr>
                    <tr>
                      <th>No SK Pengakuan </th>
                      <td>: </td>
                      <td>{organizer ? organizer.noRef : null}</td>
                    </tr>
                    <tr>
                      <th>Alamat Website</th>
                      <td>:</td>
                      <td><a href={organizer ? organizer.website : null} target="_blank">{organizer ? organizer.website : null} </a></td>
                    </tr>
                    <tr>
                      <th>Penanggung Jawab</th>
                      <td>:</td>
                      <td>{organizer ? organizer.PIC : null}</td>
                    </tr>
                    <tr>
                      <th>No Telepon</th>
                      <td>:</td>
                      <td>{organizer ? organizer.phone : null}</td>
                    </tr>
                    <tr>
                      <th>Jenis PSrE</th>
                      <td>:</td>
                      <td>{organizer ? organizer.type : null}</td>
                    </tr>
                    <tr>
                      <th>Status Pengakuan</th>
                      <td>:</td>
                      <td>{organizer ? organizer.status : null}</td>
                    </tr>
                    <tr>
                      <th>Terdaftar Tanggal</th>
                      <td>:</td>
                      <td>{organizer ? moment(organizer.registeredDate).format('DD-MM-YYYY') : null}</td>
                    </tr>
                    <tr>
                      <th>Masa Berlaku</th>
                      <td>:</td>
                      <td>{organizer ? `${moment(organizer.registeredDate).format('DD-MM-YYYY')} s.d ${moment(organizer.expireDate).format('DD-MM-YYYY')}` : null}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-md-6 text-center">
                <h1>QR CODE</h1>
                <QRCode value={qrCodeURL} logo={logoKominfo} logoWidth={100} logoHeight={100} size={256}/>
                <div className="well"><a  href={qrCodeURL} target="_blank">{qrCodeURL}</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}